<button id="mybtn" (click)="testNotify()" style="display: none;">Test Button</button>
<router-outlet (activate)="commonService.onActivate($event)"></router-outlet>

<audio controls id="audio-file" style="display: none;">
  <source src="assets/audio/notification.mp3" type="audio/mpeg">
</audio>

<div *ngIf="commonService.toastMsg" class="toastbar">
  <div id="toaster-div">
    <div *ngIf="commonService.toastMsg" id="snackbar" [ngClass]="commonService.toastErr? 'red':'green'">
      <div class="px-0" >
        {{commonService.toastMsg}}
      </div>
    </div>
  </div>
</div>